import { call, put } from 'redux-saga/effects';

import { ActionType } from 'interfaces';
import { ChallengesAPI, WidgetAPI } from 'services';
import {
  initializeDetail,
  setWidgetStatus,
  widgetGlobalViewChallenges,
  widgetPointsDetails,
} from 'actions/widget.actions';
import { LOADING_STATUS } from 'constants/status';

export function* getWidgetPointsDetailsSaga({ payload }: ActionType): unknown {
  const { widgetId } = payload;

  try {
    yield put(setWidgetStatus(widgetId, LOADING_STATUS.PENDING));
    yield put(initializeDetail('pointDetail', widgetId));
    const { data } = yield call(WidgetAPI.getWidgetPointsDetails, widgetId);
    yield put(
      widgetPointsDetails.success({ widgetId, data: data['hydra:member'] }),
    );
    yield put(setWidgetStatus(widgetId, LOADING_STATUS.RESOLVED));
  } catch (error) {
    yield put(widgetPointsDetails.failure({ widgetId, error }));
    yield put(setWidgetStatus(widgetId, LOADING_STATUS.REJECTED));
  }
}

export function* getWidgetGlobalViewChallengesSaga({
  payload,
}: ActionType): unknown {
  const { widgetId, type, status } = payload;

  try {
    yield put(setWidgetStatus(widgetId, LOADING_STATUS.PENDING));
    yield put(initializeDetail('challenges', widgetId));
    const { data } = yield call(ChallengesAPI.getUserGlobalView, type, status);
    yield put(
      widgetGlobalViewChallenges.success({
        widgetId,
        challenges: data['hydra:member'],
      }),
    );
    yield put(setWidgetStatus(widgetId, LOADING_STATUS.RESOLVED));
  } catch (error) {
    yield put(widgetGlobalViewChallenges.failure({ widgetId, error }));
    yield put(setWidgetStatus(widgetId, LOADING_STATUS.REJECTED));
  }
}
